<template>
  <JobBoard :locations="locations" :departments="departments" :posts="posts" :translate="translate" />
</template>

<script setup>
import { useTranslationStore } from '@/stores/translations'

const translationStore = useTranslationStore()
const translate = translationStore.translate

const props = defineProps({
  locations: {
    type: Object,
    required: true,
  },
  departments: {
    type: Object,
    required: true,
  },
  posts: {
    type: Object,
    required: true,
  },
});


// Dynamically import the Download component
const JobBoard = defineAsyncComponent(() =>
  import(`@/components/apps/JobBoard.vue`)
);
</script>
